<mat-toolbar class="app-header mat-elevation-z3">
    <mat-toolbar-row>
        <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span *ngIf="menuEnabled|async" class="mr-15">
                    <ng-container *appVar="!!(menuShown|async) as showMenu">
                        <button mat-button (click)="toggleMenu(!showMenu)" class="header-icon" color="primary"
                                [title]="(showMenu ? 'Hide menu' : 'Show menu')|i18n">
                            <app-icon name="fal-bars"></app-icon>
                        </button>
                    </ng-container>
                </span>
                <span *ngIf="entityTreeEnabled|async" class="mr-15">
                    <ng-container *appVar="!!(entityTreeShown|async) as showTree">
                        <button mat-button (click)="toggleEntityTree(!showTree)" class="header-icon" color="primary"
                                [title]="(showTree ? 'Hide resource menu' : 'Show resource menu')|i18n">
                            <app-icon name="fal-sitemap"></app-icon>
                        </button>
                    </ng-container>
                </span>
                <span>
                    <a mat-button routerLink="/c">
                        <img alt="Rose logo" src="assets/logo.png" class="header-logo" appBusy>
                    </a>
                </span>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <ng-container *ngIf="profile|async as profile">
                    <button *ngIf="!(isAdvUser|async)" mat-button class="header-icon mat-primary" color="primary"
                            [title]="'Connectivity'|i18n"
                            (click)="openConnectivity()">
                        <app-icon name="fal-broadcast-tower"></app-icon>
                    </button>
                    <button mat-button class="header-icon mat-primary" color="primary"
                            [matMenuTriggerFor]="userMenu"
                            [title]="'User account settings'|i18n">
                        <app-icon name="fal-user"></app-icon>
                    </button>
                    <mat-menu #userMenu="matMenu">
                        <div class="user-menu-header" fxLayout="row" fxLayoutAlign="center">
                            <span *ngIf="(!(isRepUser|async) && !(isAdvUser|async)) || username">{{'Hello, {0}'|i18n:getNameFor(profile)}}</span>
                            <span *ngIf="((isRepUser|async) || (isAdvUser|async)) && !username">{{'Hello'|i18n}}</span>
                        </div>
                        <mat-divider></mat-divider>
                        <ng-container *ngIf="profile.canOperate">
                            <button mat-menu-item class="user-menu-button"
                                    [routerLink]="['/c', 'change-user-profile']">
                                <app-icon fxFlex="10" name="fal-user" class="text-primary"></app-icon>
                                <span class="ml-12 user-menu-button-text">{{'Profile'|i18n}}</span>
                            </button>
                            <button *ngIf="isUserAdmin|async" mat-menu-item class="user-menu-button"
                                    [routerLink]="['/c', 'user-admin-panel']">
                                <app-icon fxFlex="10" name="fal-user-lock" class="text-primary"></app-icon>
                                <span class="ml-12 user-menu-button-text">{{'User administration'|i18n}}</span>
                            </button>
                            <button *ngIf="isPermAdmin|async" mat-menu-item class="user-menu-button"
                                    [routerLink]="['/c', 'permissions']">
                                <app-icon fxFlex="10" name="fal-key" class="text-primary"></app-icon>
                                <span class="ml-12 user-menu-button-text">{{'Permission management'|i18n}}</span>
                            </button>
                        </ng-container>
                        <button mat-menu-item class="user-menu-button" (click)="logout()">
                            <app-icon fxFlex="10" name="fal-sign-out-alt" class="text-primary"></app-icon>
                            <span class="ml-12 user-menu-button-text">{{'Logout'|i18n}}</span>
                        </button>
                    </mat-menu>
                </ng-container>
            </div>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
